export const ORDER_REVIEW_ACCORDION_LOCALSTORAGE_KEY_PREFIX: string = 'accordion-orderReview-';
